package demos.buttons

import androidx.compose.animation.core.*
import androidx.compose.foundation.background
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.LinearProgressIndicator
import androidx.compose.material.LocalContentColor
import androidx.compose.material.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.scale
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.launch


const val FLIP_BUTTON = "64a3533d411ac50100f68e778a2fb094cf84586a2f44e03669ccf33080022521"

@Composable
fun FlipButton() {
    var touched by remember { mutableStateOf(false) }

    val scale by animateFloatAsState(
        targetValue = if (touched) .9f else 1f, animationSpec = spring(
            dampingRatio = Spring.DampingRatioMediumBouncy,
            stiffness = Spring.StiffnessMediumLow
        )
    )

    var showProgressBar by remember { mutableStateOf(false) }
    val rotateAnimation = remember { Animatable(0f) }
    val scope = rememberCoroutineScope()

    Box(
        modifier = Modifier
            .padding(4.dp)
            .pointerInput(Unit) {
                detectTapGestures(
                    onPress = {
                        touched = true
                        awaitRelease()
                        scope.launch {
                            rotateAnimation.animateTo(90f, tween(easing = FastOutLinearInEasing, durationMillis = 150))
                            showProgressBar = !showProgressBar
                            rotateAnimation.snapTo(-90f)
                            rotateAnimation.animateTo(0f, tween(easing = FastOutLinearInEasing, durationMillis = 150))
                        }
                        touched = false
                    }
                )
            }
            .graphicsLayer { rotationX = rotateAnimation.value }
            .scale(scale)
            .background(
                color = Color.White,
                RoundedCornerShape(10.dp)
            )
            .defaultMinSize(minHeight = 40.dp, minWidth = 200.dp)
            .padding(horizontal = 24.dp, vertical = 8.dp),
        contentAlignment = Alignment.Center,
    ) {
        CompositionLocalProvider(
            LocalContentColor provides Color.Black,
        ) {
            Row {
                if (!showProgressBar) {
                    Text(text = "Flip Button")
                } else {
                    LinearProgressIndicator(
                        Modifier.width(60.dp),
                        color = Color.Black,
                        strokeCap = StrokeCap.Round
                    )
                }
            }
        }
    }
}